import { stringify } from 'query-string';

import { entityTypeToApiType } from 'helpers/mapEntityTypes';

import { EntityTypes } from 'context/entityContext';
import getRegionBreakdown from 'helpers/getRegionBreakdown';
import getCountryIds from 'helpers/getCountryIds';

interface IRadioKPIUrlArgs {
  countryIds?: string[] | string;
  download?: boolean;
  entityType: EntityTypes;
  entityIds: string[];
  region?: string;
  compareMode?: string;
  customRegion?: string | string[];
}

export default function getRadioKPIUrl(args: IRadioKPIUrlArgs): string {
  const {
    countryIds,
    download,
    entityType,
    entityIds,
    region,
    compareMode,
    customRegion,
  } = args;
  const type = entityTypeToApiType(entityType);

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    download,
    regionBreakdown: getRegionBreakdown(
      countryIds,
      region,
      compareMode,
      customRegion
    ),
  });

  return `/api/radio/kpi/${type}/${entityIds}?${params}`;
}
